import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OfflineService } from 'src/app/offline/offline.service';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { NotificationService } from '../services/notifications.service';
import { PageHeader } from 'src/app/models/common/page-header';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';

@Component({
  selector: '',
  template: '',
})
export class MessagesHandler extends BaseSearchComponent<NotificationService> implements OnInit {
  messagesNotificationResponseData = [];
  unreadMessageCount = 0;
  totalMsgCount = 0;
  public isAllBtnClicked: boolean;
  public isUnReadBtnClicked: boolean;
  public headerText: string;
  public detailMessage: string;

  constructor(
    public service: NotificationService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService,
    public offlineService: OfflineService
  ) {
    super(service, router);
    this.isAllBtnClicked = true;
    this.isUnReadBtnClicked = false;
    this.getMessagesNotification();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getMessagesNotification();
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'messages',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = this.settingService.getLabelValue('messages');
    return header;
  }

  allBtnClicked() {
    this.isAllBtnClicked = true;
    this.isUnReadBtnClicked = false;
    return;
  }

  unReadBtnClicked() {
    this.isAllBtnClicked = false;
    this.isUnReadBtnClicked = true;
    return;
  }

  messageShowHide(msgGuid?) {
    this.messagesNotificationResponseData.filter((msgShow) => {
      if (msgGuid != undefined && msgShow.guid == msgGuid) {
        msgShow.isMessageShow = true;
      } else {
        msgShow.isMessageShow = false;
      }
    });
    return;
  }

  getMessagesNotification() {
    this.service.getNotification('MESSAGE').subscribe(
      (body) => {
        this.unreadMessageCount = 0;
        let response = JSON.parse(JSON.stringify(body));
        if (response.data != undefined)
          this.messagesNotificationResponseData = response.data['MessageNotificationList'];
        this.totalMsgCount = this.messagesNotificationResponseData.length;
        this.messagesNotificationResponseData.filter((msg) => {
          if (msg.detailMessage.length > 50) msg.isMessageShow = false;
          else msg.isMessageShow = true;

          if (
            msg.notificationReadFlag == 'NO' ||
            msg.notificationReadFlag == ' ' ||
            msg.notificationReadFlag == undefined ||
            msg.notificationReadFlag == null
          )
            this.unreadMessageCount = this.unreadMessageCount + 1;
        });
      },
      (error) => {
        console.log('Error:', error);
        this.service.handleError(error);
      }
    );
  }

  messageRead(message) {
    this.headerText = message.notificationSubject;
    this.detailMessage = message.detailMessage;
    this.openPopup('showMessagePopup');
    if (
      message.notificationReadFlag == ' ' ||
      message.notificationReadFlag == 'NO' ||
      message.notificationReadFlag == undefined ||
      message.notificationReadFlag == null
    ) {
      message.notificationReadFlag = 'YES';
      this.service.updateNotification(message.notificationSeq, message.notificationReadFlag).subscribe((data) => {
        if (this.unreadMessageCount > 0) this.unreadMessageCount = this.unreadMessageCount - 1;
        return;
      });
    }
  }

  closeMessagePopup() {
    this.closePopup('showMessagePopup');
  }
}
